
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalBOMGrid extends Serenity.EntityGrid<POSApprovalBOMRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalBOM'; }
        protected getDialogType() { return POSApprovalBOMDialog; }
        protected getIdProperty() { return POSApprovalBOMRow.idProperty; }
        protected getInsertPermission() { return POSApprovalBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalBOMRow.localTextPrefix; }
        protected getService() { return POSApprovalBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}